export default __webpack_public_path__ + "static/media/start-ar.0ab3756e.jpg";